require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./winpe-edge-masterclass-series-with-trilegal.json") })
        }
      }, "path---winpe-edge-masterclass-series-with-trilegal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---winpe-edge-masterclass-series-with-trilegal!./.cache/json/winpe-edge-masterclass-series-with-trilegal.json
// module id = 1225
// module chunks = 231608221292675